const configurationElement = document.getElementById('LyoComponentModules');

if (configurationElement) {
  try {
    const modules = JSON.parse(configurationElement.textContent);
    const requestedSources = new Set();

    function loadModules(root) {
      for (const { selector, source } of modules) {
        const hasComponent =
          root instanceof Element && root.matches(selector)
            ? true
            : root.querySelector(selector);

        if (selector && source && hasComponent && !requestedSources.has(source)) {
          requestedSources.add(source);
          import(source).catch((error) => {
            requestedSources.delete(source);
            console.error(`Unable to load the component module for "${selector}".`, error);
          });
        }
      }
    }

    loadModules(document);
    document.addEventListener('shopify:section:load', (event) => loadModules(event.target));
  } catch (error) {
    console.error('Unable to load Lyo component modules.', error);
  }
}
